/* 変数
-----------------------------------------------------*/

// リロード時のスクロール位置復元無効化
window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    window.scrollTo(0, 0);
  });
});

//よく使うやつ
const html_body = 'html, body';

//フラグ
var naviFlag = 0;

//is-active
var isActive = 'is-active';

const w = $(window).width();

const jsHeader = '#js-header';

//breakpoint
const breakpoint_sp = window.matchMedia('(max-width: 500px)');
const breakpoint_tab = window.matchMedia('(max-width: 1024px)');
const breakpoint = window.matchMedia('(max-width: 850px)');


/* 動作設定
-----------------------------------------------------*/

//画面の読み込み時に動く
$(function(){

  const pcMediaQuery = window.matchMedia('(min-width: 851px)').matches;
  const spMediaQuery = window.matchMedia('(max-width: 850px)').matches;
    //*ナビ設定
    if(pcMediaQuery) {
      $('.header_nav-btn').on('click', (function (e) {
          0 == naviFlag
              ? pcNaviOpen()
              : 1 == naviFlag && pcNaviClose()
      })),
      $('.header_nav-list a').on('click', (function () {
          pcNaviClose()
      }));
    } else if(spMediaQuery) {
      $('.header_nav-btn').on('click', (function (e) {
          0 == naviFlag
              ? spNaviOpen()
              : 1 == naviFlag && spNaviClose()
      })),
      $('.header_nav-list a').on('click', (function () {
          spNaviClose()
      }));
    }

    //*ページ内リンクの遷移設定
    in_page_link();

    // リロード時　一番上へ
    reload_page_top();

    //popup
    popupAll();

});

//画面リサイズでリロード
breakpoint.addEventListener('change', function() {
  window.location.reload();
})

// 画面リサイズ後に動く
$(window).on('resize', (function () {
  const resizeMediaQuery = window.matchMedia('(min-width: 851px)').matches || spNaviClose();
}));

/*------- header -----------*/
ScrollTrigger.matchMedia({
  "(min-width: 501px)": function() {
    gsap.to('.header_wrapper', {
      scrollTrigger: {
        trigger: '.hotel_image',
        start: 'bottom-=150 top',
        toggleAction: 'play none none reverse',
        onEnter: () => {
          document.querySelector('.header_wrapper').classList.add('is-active');
        },
        onLeaveBack: () => {
          document.querySelector('.header_wrapper').classList.remove('is-active');
          pcNaviClose();
        },
        // markers: true
      }
    });
  },
  "(max-width: 500px)": function() {
    gsap.to('.header_wrapper', {
      scrollTrigger: {
        trigger: '.hotel_image',
        start: 'bottom-=80 top',
        toggleAction: 'play none none reverse',
        onEnter: () => {
          document.querySelector('.header_wrapper').classList.add('is-active');
        },
        onLeaveBack: () => {
          document.querySelector('.header_wrapper').classList.remove('is-active');
        },
        // markers: true
      }
    });
  }
});


/* 　　　関数
-----------------------------------------------------*/
function pcNaviOpen() {
    $('.header_nav-btn').addClass(isActive),
    $('.header_nav_wrapper').addClass(isActive),
    $('.header_nav_inner').addClass(isActive),
    $('.header_inner').addClass(isActive);
    naviFlag = 1
}
function pcNaviClose() {
    $('.header_nav-btn').removeClass(isActive),
    $('.header_nav_wrapper').removeClass(isActive),
    $('.header_inner').removeClass(isActive),
    $('.header_nav_inner').removeClass(isActive),
    naviFlag = 0
}

function spNaviOpen() {
    $('body').addClass('scroll-prevent'),
    $('html').css('top', -$(window).scrollTop() + 'px'),
    $('.header_nav-btn').addClass(isActive),
    $('.header_nav_wrapper').addClass(isActive),
    $('.header_nav_inner').addClass(isActive),
    naviFlag = 1
}

function spNaviClose() {
    $('body').removeClass('scroll-prevent'),
    $(window).scrollTop($(window).scrollTop()),
    $('.header_nav-btn').removeClass(isActive),
    $('.header_nav_wrapper').removeClass(isActive),
    $('.header_nav_inner').removeClass(isActive),
    naviFlag = 0
}


//*ページ内リンクの遷移設定　ヘッダーの高さを取得
function in_page_link() {
    $('a[href^="#"]').click(function () {
        var headerHight = $(jsHeader).outerHeight(true);
        var href = $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'body' : href);

        var position = target.offset().top - headerHight;

        $(html_body).animate({ scrollTop: position }, 550, 'swing');
        setTimeout(10000);
        return false;

    });
}

// リロード時　一番上へ
function reload_page_top() {
  $(html_body).animate({ scrollTop: 0 }, '1');
}


//popup
function popupAll() {

  $('.popup_carrechocolat_btn').on('click',function(){
    $('#popup-carrechocolat').fadeIn();
    $('.popup_over').fadeIn();
    $('body').addClass('scroll-prevent');
  });

  $('.popup_baton_btn').on('click',function(){
    $('#popup-baton').fadeIn();
    $('.popup_over').fadeIn();
    $('body').addClass('scroll-prevent');
  });

  $('.popup_bouchee_btn').on('click',function(){
    $('#popup-bouchee').fadeIn();
    $('.popup_over').fadeIn();
    $('body').addClass('scroll-prevent');
  });

  $('.popup_varie_btn').on('click',function(){
    $('#popup-varie').fadeIn();
    $('.popup_over').fadeIn();
    $('body').addClass('scroll-prevent');
  });
  
  $('.popup-close, .popup_over').on('click',function(){
    $('#popup-carrechocolat').fadeOut();
    $('#popup-baton').fadeOut();
    $('#popup-bouchee').fadeOut();
    $('#popup-varie').fadeOut();
    $('.popup_over').fadeOut();
    $('body').removeClass('scroll-prevent');
  });
}


/*-------------------------------------------
 *            スクロールアニメーション
 *-------------------------------------------*/

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.matchMedia({
// PC用
"(min-width: 1025px)": function() {
  ScrollTrigger.create({
      trigger: '.reception_show_wrap',   
      start: 'top-=100 center',  
      toggleClass: {
        targets: '.reception_inner, .reception_bg',
        className: 'is-active'
      },
      once: true,    
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: '.corridor_show_wrap',   
      start: 'top-=200 center', 
      toggleClass: {
        targets: '.corridor_inner, .corridor_bg',
        className: 'is-active'
      },
      once: true,     
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: '.lounge_show_wrap',  
      start: 'top-=200 center',
      toggleClass: {
        targets: '.lounge_inner, .lounge_bg',
        className: 'is-active'
      },
      once: true,
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: '.keyToRoom_show_wrap',  
      start: 'top-=200 center', 
      toggleClass: {
        targets: '.keyToRoom_inner, .keyToRoom_bg',
        className: 'is-active'
      }, 
      once: true,
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: '.cacaohotel_show_wrap',   
      start: 'top-=150 center',
      end: 'center center',
      toggleClass: {
        targets: '.cacaohotel_inner, .cacaohotel_bg',
        className: 'is-active'
      },      
      once: true,
      // 下がったマスクを削除
      onLeave:() => {
        document.querySelector('.cacaohotel_bg').classList.add('none');
      },
      // markers: true,
    });
  },

  "(max-width: 1024px)": function() {
// SP用
  ScrollTrigger.create({
      trigger: '.reception_show_wrap',   
      start: 'top-=500 top',      
      toggleClass: {
        targets: '.reception_inner, .reception_bg',
        className: 'is-active'
      },
      once: true,
      // markers: true,
    });

    ScrollTrigger.create({
      trigger: '.corridor_show_wrap',   
      start: 'top-=200 center',        
      toggleClass: {
        targets: '.corridor_inner, .corridor_bg',
        className: 'is-active'
      },
      once: true,
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: '.lounge_show_wrap',  
      start: 'top-=200 center',   
      toggleClass: {
        targets: '.lounge_inner, .lounge_bg',
        className: 'is-active'
      },
      once: true,
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: '.keyToRoom_show_wrap',  
      start: 'top-=200 center',  
      toggleClass: {
        targets: '.keyToRoom_inner, .keyToRoom_bg',
        className: 'is-active'
      },
      once: true,
      // markers: true,
    });
    ScrollTrigger.create({
      trigger: '.cacaohotel_show_wrap',   
      start: 'top-=100 center',      
      end: 'center center',
      toggleClass: {
        targets: '.cacaohotel_inner, .cacaohotel_bg',
        className: 'is-active'
      },
      once: true,
      onLeave:() => {
        document.querySelector('.cacaohotel_bg').classList.add('none');
      },
      // markers: true,
    });
  }
});





/*-------　slider ----------*/

$(document).ready(function(){
  $('.top_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,        
    speed: 25000,            
    cssEase: 'linear',       
    infinite: true,          
    arrows: false,           
    pauseOnHover: false,     
    draggable: false,
    swipe: false
  });
});
$(document).ready(function(){
  $('.bottom_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,        
    speed: 25000,           
    cssEase: 'linear',       
    infinite: true,          
    arrows: false,           
    pauseOnHover: false,     
    draggable: false,
    swipe: false
  });
});







